import React from 'react'
// import { observer } from 'mobx-react';
// import { useStores } from 'hooks/useStores';
import { frontApi, API_ROUTES } from '_app/api';
import { Box, Button } from '@chakra-ui/react';
import Input from 'components/Form/Input';
import Select from 'components/Form/Select';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useStores } from 'hooks/useStores';

const schema = yup.object().shape({
  message: yup.string().required(),
  type: yup.string(),
  namespace: yup.string(),
  room: yup.string(),
});

const typeOptions = [
  {
    label: 'info',
    value: 'info'
  },
  {
    label: 'warning',
    value: 'warning'
  },
  {
    label: 'error',
    value: 'error'
  },
  {
    label: 'success',
    value: 'success'
  },
  {
    label: 'default',
    value: 'default'
  },
]

const MessagesPage = () => {
  const { t } = useTranslation();

  const {
    gamesStore: {
      games,
      gamesInfo,
    },
  } = useStores();

  const methods = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async (data) => {
    await frontApi.post(API_ROUTES.devMsg, data);
  }

  const namespacesOptions = games.map(({ shortName, name }) => ({
    value: shortName,
    label: name,
  }))

  return (
    <div>
      <Box p={8} bg="white" rounded="lg">
        <FormProvider {...methods}>

          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Input name="message" label={t('Message')} />
            <Select name="type" label={t('Type')} options={typeOptions} />
            <Select name="namespace" label={t('Namespace')} options={namespacesOptions} />
            <Input name="room" label={t('Room')} />
            <Button type="submit">{t('Send')}</Button>
          </form>
        </FormProvider>
      </Box>
    </div>
  )
}

export default MessagesPage
